/** Pixel checkmark that inherits `currentColor`. Used in place of the `✓`
 *  glyph, which falls back to a system font and drifts off the pixel-font
 *  baseline inside buttons. */

export function Check({ size = 10 }: { size?: number }) {
  return (
    <svg
      aria-hidden="true"
      width={(size * 7) / 5}
      height={size}
      viewBox="0 0 7 5"
      shapeRendering="crispEdges"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <rect x="6" y="0" width="1" height="1" fill="currentColor" />
      <rect x="5" y="1" width="1" height="1" fill="currentColor" />
      <rect x="0" y="2" width="1" height="1" fill="currentColor" />
      <rect x="4" y="2" width="1" height="1" fill="currentColor" />
      <rect x="1" y="3" width="1" height="1" fill="currentColor" />
      <rect x="3" y="3" width="1" height="1" fill="currentColor" />
      <rect x="2" y="4" width="1" height="1" fill="currentColor" />
    </svg>
  );
}
